import { Injectable } from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionService } from 'src/backend/services/permission.service';
import { Permission } from '../models/permission';
import { SharedConstants } from '../models/shared-constants';

@Injectable({
    providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

    constructor(
        private router: Router,
        private permissionService: PermissionService
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const permissions = next.data['permissions'] ?? {} as Permission;
        let isUserHasPermission = false;
        isUserHasPermission = this.permissionService.isUserHasPermission(permissions);

        if (isUserHasPermission === false) {
            this.router.navigate(['/' + SharedConstants.PAGE_ERROR + '/' + SharedConstants.ACCESS_DENIED]);
        }

        return isUserHasPermission;
    }
}
